import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import { useDataContext } from '../../../../../context';
import { useGetAllZipcodesSimpleQuery } from '../../../../../services/endpoints/places/zipcode';
import { getCurrentUser } from '../../../../../services/helper';
import { StepProps } from './AddEditTerritory';

const currentUser = getCurrentUser();

export const TerritoryForm = ({ touched, errors, values }: StepProps) => {
  const { locationOptions } = useDataContext();
  const isGlobalUser = currentUser?.isGlobal;
  const { data: zipCodes, error: zipCodesError } = useGetAllZipcodesSimpleQuery({
    data: { orderBy: { field: 'code', order: 'asc' } },
    scope: 'available'
  });

  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Territory Details" />
        </Col>
        <Col className="pe-1">
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="title"
          >
            <FormLabel required>Title</FormLabel>
            <Field
              name="title"
              type="text"
              as={Form.Control}
              isInvalid={touched.title && !!errors.title}
              aria-required
            />
            <ErrorMessage name="title">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          {isGlobalUser ? (
            <Form.Group
              className="mb-lg-3 mb-1"
              controlId="location_id"
            >
              <Field
                as={FormSelect}
                name="location_id"
                label="Location"
                required
                options={locationOptions}
              />
            </Form.Group>
          ) : (
            <></>
          )}

          {!values?.id ? (
            <Form.Group
              className="mb-lg-3 mb-1"
              controlId="zip_codes"
            >
              <FormLabel required>Zip Code</FormLabel>
              <Field
                name="zip_codes"
                as={'textarea'}
                className={`form-control ${touched.zip_codes && !!errors.zip_codes ? 'is-invalid' : ''}`}
                disabled={!values?.location_id?.value}
                aria-required
              />
              <Form.Text className="text-info">
                {values?.location_id?.value
                  ? 'Enter Zip codes as a space- or comma-separated list'
                  : 'Select a location above before entering zip codes'}
              </Form.Text>
              {errors.zip_codes?.includes('Warning') && (
                <Form.Text className="text-warning">{errors.zip_codes}</Form.Text>
              )}
              <ErrorMessage name="zip_codes">
                {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
              </ErrorMessage>
            </Form.Group>
          ) : (
            <Form.Group
              className="mb-lg-3 mb-1"
              controlId="zip_code_ids"
            >
              <FormSelect
                name="zip_code_ids"
                label="Zip Codes"
                multiple={true}
                options={
                  zipCodes?.map((zipCode) => ({
                    value: zipCode.id,
                    label: String(zipCode.code)
                  })) ?? []
                }
                loadingError={zipCodesError ? 'Error loading Zip Codes' : undefined}
              />
              <ErrorMessage name="zip_code_ids">
                {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
              </ErrorMessage>
            </Form.Group>
          )}
        </Col>
      </Row>
    </>
  );
};
